import { TextArea } from "components/primitives/TextArea";
import { useEffect } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";
import { WidgetSettingFC } from "types/Setting";
import { isPowerPointLink } from "util/iframeUtils";

import { EmbedState } from "../inteface";

interface TextAreaSettingsProps {
  placeholder?: string;
  settingName: string;
}

export const TextAreaSettings: WidgetSettingFC<EmbedState, TextAreaSettingsProps> = (props) => {
  const { info, setData, data, state } = props;

  useEffect(() => {
    if (!data) {
      setData({
        link: state.link,
        isShowPPT: false,
        hasError: false,
      });
    }
  }, []);

  const handleChange = (value: string) => {
    const isValid = isPowerPointLink(value);

    if (isValid) {
      setData({
        link: value,
        isShowPPT: true,
        hasError: false,
      });
    } else {
      setData({
        link: value,
        isShowPPT: false,
        hasError: true,
      });
    }
  };

  return (
    <TextAreaBoxStyled>
      <TextAreaLabelStyled>{info.settingName}</TextAreaLabelStyled>

      <TextArea
        placeholder={info?.placeholder}
        value={data?.link}
        onChange={handleChange}
        hasError={Boolean(data?.link) && state.hasError}
        errorMessage="You need to paste working code"
      />
    </TextAreaBoxStyled>
  );
};

export const TextAreaBoxStyled = styled("div")`
  margin-bottom: 20px;

  textarea {
    min-height: 150px;
    height: 20cqh;
  }
`;

export const TextAreaLabelStyled = styled(Form.Label)`
  font-weight: 600;
  font-size: 14pt;
  margin-bottom: 0.75rem;
`;
